import * as actions from './actions';
import immerHandleActions from 'redux/utils/immerHandleActions';

interface state extends types.redux.timestamp.state {}

const initialState = () => ({
	value: '',
});

const reducer = {
	[actions.setTimestamp]: (state: state, action: { payload: string }) => ({
		value: action.payload,
	}),
	'persist/REHYDRATE': (state: state, { payload }: any) => ({
		...initialState(),
		...state,
		value: payload?.timestamp?.value || '',
	}),
};

export default immerHandleActions(reducer, initialState());
